import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';
import { IAgent } from './types';

export interface ILiveChatAgentStatus {
  readonly id: string;
  readonly type: MESSAGES.AGENT_STATUS;
  readonly role: string; // role === agent.id
  readonly rm: false;
  readonly avatar: boolean;
  readonly agent: IAgent;
  readonly isJoined: boolean;
}

export const agentStatus = (data, isJoined: boolean): ILiveChatAgentStatus => ({
  id: data.id || uuid(),
  type: MESSAGES.AGENT_STATUS,
  role: data.agent.id,
  rm: false,
  avatar: true,
  agent: data.agent,
  isJoined,
});
